import './less/your-account.less';
import React, { Component } from 'react';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import { Row, Col, Icon, Collapse } from 'antd';
import { VIEWS } from '../../../utils/yourAccountUtils';
import AccountInfo from './AccountInfo';
import ChangeSecurityQuestions from './ChangeSecurityQuestions';
import ManageEmailPreferences from './ManageEmailPreferences';
import YourAccountLoadingIndicator from './YourAccountLoadingIndicator';
import ChangePassword from './ChangePassword';
import EditContactInfo from './EditContactInfo';
import * as YourAccountServices from '../../../redux/services/yourAccountServices';

export default Container({
    state: state => state.yourAccount,
    services: [ YourAccountServices ]
},
class YourAccount extends Component {
    constructor(props) { super(props); }

    getYourAccountData() {
        const
        { getYourAccountData } = this.props.services,
        { jti } = window.session;
        getYourAccountData(`/user/${jti}`);
    }

    injectProps() {
        const { displayRole } = this.props;
        return [
            <AccountInfo key={'your-account-account-info'} />,
            <ChangeSecurityQuestions key={'your-account-change-security-questions'} />,
            <ChangePassword key={'your-account-change-password'} />,
            <ManageEmailPreferences key={'your-account-manage-email-preferences'} />,
            <EditContactInfo key={'your-account-edit-contact-info'} />
        ].map((e, i) => React.cloneElement(e, {...this.props, displayRole: displayRole }));
    }

    componentDidMount() {
        this.getYourAccountData();
    }

    componentDidUpdate(prev) {
        const
        { services } = this.props,
        prevRequests = prev.requests,
        currRequests = this.props.requests;

        switch(currRequests.data.status) {
            case 'success':
            case 'failure':
                if(prevRequests.data.status === 'pending') {
                    this.getYourAccountData();
                    services.resetDataRequest();
                    services.toggleShowView(true);
                }
                break;
        }

        switch(currRequests.updateContactInfo.status) {
            case 'success':
            case 'failure':
                if(prevRequests.updateContactInfo.status === 'pending') {
                    services.resetContactInfoRequest();
                    this.getYourAccountData();
                }
                break;
        }
    }

    render() {
        const
        { view, showView } = this.props,
        { data } = this.props.requests,
        views = this.injectProps();

        if(showView) switch(view) {
            case VIEWS.YOUR_ACCOUNT: return views[0];
            case VIEWS.CHANGE_SECURITY_QUESTIONS: return views[1];
            case VIEWS.CHANGE_PASSWORD: return views[2];
            case VIEWS.EMAIL_PREFERENCES: return views[3];
            case VIEWS.EDIT_CONTACT_INFO: return views[4];
        }

        return <YourAccountLoadingIndicator />;
    }
});
